module.exports = __webpack_public_path__ + "static/media/success_icon.f5bf91cc.svg";